import ActionLogListController from './controller/list-controller';
import listTemplate from './views/list.tpl.html';

angular
    .module('festzelt-os.modules.action_log')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.action_log', {
            abstract: true,
            url: '/action-log',
            template: '<ui-view/>'
        })
        .state('app.action_log.list', {
            url: '',
            data: {
                right: 'action-log::list'
            },
            controller: ActionLogListController,
            controllerAs: 'vm',
            templateUrl: listTemplate
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/action_log/routes.js